import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderBulkSelection, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';

import { useGetServiceOrderIdsMutation } from '../../../api/serviceOrdersApi';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { FIXED_SERVICE_ORDER_IDS_CACHE_KEY } from '../bulkUpdate/ServiceOrderBulkSelectionDropdown';

export const SERVICE_ORDER_SELECTION_LOADER_TEST_ID = 'service-order-selection-cell-loader';

export const ServiceOrderSelectionCell = ({ orderId }: { orderId: string }) => {
    const dispatch = useAppDispatch();
    const isSelected = useAppSelector((state) => getServiceOrderBulkSelection(state).includes(orderId));
    const [, { isLoading }] = useGetServiceOrderIdsMutation({
        fixedCacheKey: FIXED_SERVICE_ORDER_IDS_CACHE_KEY,
    });

    const onSelect = () => {
        if (isSelected) {
            dispatch(serviceOrdersSlice.actions.removeFromBulkSelection([orderId]));
        } else {
            dispatch(serviceOrdersSlice.actions.addToBulkSelection([orderId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove order from selection' : 'Add order to selection';

    return (
        <td className="table-checkbox">
            {isLoading ? (
                <ContentLoader data-testid={SERVICE_ORDER_SELECTION_LOADER_TEST_ID} />
            ) : (
                <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
            )}
        </td>
    );
};
